<template>
    <div class="modal fade" id="eduDrvSessionDetailsModal" tabindex="-1" role="dialog"   aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">جزئیات جلسه</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">

                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-account-title">مربی</div>
                            <div class="form-account-row">
                                <input class="input-field text-right" readonly v-model="eduDrvSessionDetail.EduName" type="text" placeholder="">
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-account-title">سیستم و پلاک خودرو</div>
                            <div class="form-account-row">
                                <input class="input-field text-right" readonly v-model="eduDrvSessionDetail.CarSystemAndPlaque" type="text" placeholder="">
                            </div>
                        </div>

                        <!--<div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-account-title">سیستم خودرو</div>
                            <div class="form-account-row">
                                <input class="input-field text-right" readonly v-model="eduDrvSessionDetail.CarSystem" type="text" placeholder="">
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-account-title">پلاک خودرو</div>
                            <div class="form-account-row">
                                <input class="input-field text-right" readonly v-model="eduDrvSessionDetail.Plate" type="text" placeholder="">
                            </div>
                        </div>-->

                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-account-title">زمان ثبت جلسه</div>
                            <div class="form-account-row">
                                <input class="input-field text-right" readonly v-model="eduDrvSessionDetail.SesRegDateTime" type="text" placeholder="">
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-account-title">زمان شروع جلسه</div>
                            <div class="form-account-row">
                                <input class="input-field text-right" readonly v-model="eduDrvSessionDetail.SesStartDateTime" type="text" placeholder="">
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-account-title">زمان اتمام جلسه</div>
                            <div class="form-account-row">
                                <input class="input-field text-right" readonly v-model="eduDrvSessionDetail.SesEndDateTime" type="text" placeholder="">
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-account-title">نوع جلسه</div>
                            <div class="form-account-row">
                                <input class="input-field text-right" readonly v-model="eduDrvSessionDetail.SesTypeExpr" type="text" placeholder="">
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-account-title">شماره جلسه</div>
                            <div class="form-account-row">
                                <input class="input-field text-right" readonly v-model="eduDrvSessionDetail.DrvSesIndex" type="text" placeholder="">
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-account-title">شماره جلسه مؤثر</div>
                            <div class="form-account-row">
                                <input class="input-field text-right" readonly v-model="eduDrvSessionDetail.DrvSesNo" type="text" placeholder="">
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-account-title">هزینه جلسه (ريال)</div>
                            <div class="form-account-row">
                                <input class="input-field text-right" readonly v-model="eduDrvSessionDetail.SesCostExpr" type="text" placeholder="">
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-account-title">سهم مربی (ريال)</div>
                            <div class="form-account-row">
                                <input class="input-field text-right" readonly v-model="eduDrvSessionDetail.EduAmountExpr" type="text" placeholder="">
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-account-title">سهم خودرو (ريال)</div>
                            <div class="form-account-row">
                                <input class="input-field text-right" readonly v-model="eduDrvSessionDetail.CarAmountExpr" type="text" placeholder="">
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-account-title">هنرآموز</div>
                            <div class="form-account-row">
                                <input class="input-field text-right" readonly v-model="eduDrvSessionDetail.StdName" type="text" placeholder="">
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-account-title">موبایل هنرآموز</div>
                            <div class="form-account-row">
                                <input class="input-field text-right" readonly v-model="eduDrvSessionDetail.StdMobNo" type="text" placeholder="">
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-account-title">وضعیت جلسه</div>
                            <div class="form-account-row">
                                <input class="input-field text-right" readonly v-model="eduDrvSessionDetail.StatusExpr" type="text" placeholder="">
                            </div>
                        </div>

                    </div>
                </div>
                <div :class="{loader: !isShowLoader, 'loader-bg-black':true}">
                    <div class="df-d">
                        <img src="/assets/img/loader/loader.svg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import { httpPromise } from "../../../module/httpUtility";
    export default {
        data() {
            return {
                isShowLoader: false,
                prefix: '', 
            }
        },
        props: {
            eduDrvSessionDetail: Object,
        }, 
        methods: {

            buyProductOnSubmit: function () {
                this.$validator.validateAll().then(valid => {

                    if (valid) {
                        this.isShowLoader = true;
                        httpPromise(this, '/v1/Orders/OrderPayment/GetBankPaymentUrl', 'get', { UseCredit: true, ProductId: this.productId, Prefix: this.prefix },
                            response => {
                                toastr.success(response.data.Message);
                                this.isShowLoader = false;
                                $(function () { 
                                    $('#buyModal').modal('hide');
                                });
                            },
                            response => {
                                toastr.remove();
                                toastr.error(response.data.Message);
                                this.isShowLoader = false;
                            });
                    }
                });
            } 
        },

    }
</script>

<style scoped>
    .df-d {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
    .loader-bg-black {
        
        position: absolute;
        background-color: #80808033;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 9999;
        width: 100%;
        height: 100%
    }

        .loader-bg-black img {
            position: absolute;
            
            z-index: 100
        }

    .btn-save {
        background-color: #59b959 !important;
    }

    .btn-reject {
        background-color: #e36e6e !important;
    }

    .input-field {
        padding: 11px 11px 11px 11px !important;
    }

    .modal-content .modal-header button {
        right: unset !important;
        left: 27px !important;
        top: 30px !important;
    }

    .modal-header .close {
        padding: unset !important;
        margin: -1rem -1rem -1rem auto;
    }

    .setaddress {
        padding: 22px !important;
    }

    a:not([href]):not([tabindex]) {
        color: #fff;
    }

    .box.profile .center {
        text-align: center;
    }

    .box.no-address .desc {
        display: block;
        margin: 0 auto;
    }

    .box.profile.no-address img {
        margin-bottom: 25px;
    }

    .box.no-address {
        text-align: center;
        color: #777777;
    }

    .address-div {
        display: contents;
    }

    .box profile {
        min-height: 200px;
        width: auto;
    }

    .box {
        background: #fcfcfc;
        border: 1px solid #e5e5e5;
        -webkit-border-radius: 5px;
        border-radius: 5px;
        padding: 15px;
        width: 100%;
        margin-top: 15px;
    }

        .box .title {
            display: block;
            font-weight: 500;
            text-align: center;
        }

        .box .location {
            font-size: 12px;
            color: #777777;
            display: block;
            text-align: center;
            margin-top: 5px;
        }

        .box .desc {
            margin-top: 15px;
            text-align: center;
            display: block;
            font-size: 12px;
        }

        .box.profile .center {
            text-align: center;
        }

    .btn-lg {
        padding: 10px 25px;
    }
</style>